export enum OpenAdminBannerStatus {
  INITIAL = "initial",
  IN_PROGRESS = "in_progress",
  ERROR = "error",
  PENDING = "pending",
  COMPLETED = "completed",
  UNAVAILABLE = "unavailable",
}
